import React from 'react';
import { Link } from 'react-router-dom';
import { SEOHead } from '../../../shared/components/SEOHead';
import { CategoryShowcaseSection } from '../components/CategoryShowcaseSection';
import { categoriesPageSeo } from '../seo/categoriesPageSeo';
import '../styles/categoryShowcase.css';

const CategoriesPage: React.FC = () => (
    <>
        <SEOHead seo={categoriesPageSeo} />

        <div className="cs-page-hero">
            <div className="container">
                <h1 className="cs-page-hero-title">Shop by Category</h1>
                <p className="cs-page-hero-sub">
                    Discover India's finest handcrafted products across every category
                </p>
            </div>
        </div>

        <div style={{ padding: '32px 0 0' }}>
            <div className="container">
                <nav className="cs-breadcrumb" aria-label="Breadcrumb">
                    <Link to="/">Home</Link>
                    <span className="cs-breadcrumb-sep" aria-hidden="true">›</span>
                    <span aria-current="page">Categories</span>
                </nav>
            </div>
        </div>

        <CategoryShowcaseSection />

        <div className="container" style={{ paddingBottom: '56px' }}>
            <div className="cs-page-cta">
                <p className="cs-page-cta-text">
                    Can't find what you're looking for?
                </p>
                <Link to="/request-a-quote" className="cs-page-cta-btn">
                    Request a Custom Quote
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                </Link>
            </div>
        </div>
    </>
);

export default CategoriesPage;
